"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.APSimplifiedDrawer = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _APDrawer = require("./APDrawer.styles");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _faTimes = require("@fortawesome/pro-light-svg-icons/faTimes");
var _excluded = ["headerContent", "children", "noPadding"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var APSimplifiedDrawer = function APSimplifiedDrawer(props) {
  var headerContent = props.headerContent,
    children = props.children,
    noPadding = props.noPadding,
    rest = _objectWithoutProperties(props, _excluded);
  var classes = (0, _APDrawer.useStyles)({
    noPadding: noPadding
  });
  return /*#__PURE__*/_react["default"].createElement(_core.Drawer, _extends({}, rest, {
    classes: {
      paper: classes.paper
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.header
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: classes.close,
    onClick: function onClick(e) {
      if (props.onClose) {
        return props.onClose(e, 'escapeKeyDown');
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faTimes.faTimes
  })), /*#__PURE__*/_react["default"].createElement("div", null, headerContent)), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.body
  }, children));
};
exports.APSimplifiedDrawer = APSimplifiedDrawer;